import React from 'react';

export const MessagesSidebarContext = React.createContext({
  visible: true,
});
